"use strict";
HTMLSelectElement.prototype.setOptions = function setOptions(options) {
    this.innerHTML = Object.keys(options).map(key => `<option value="${key}">${options[key]}</option>`).join('');
};
//# sourceMappingURL=SetOptions.js.map